import { connect } from 'react-redux';
import { ReduxState } from '../../store';
import { hasArrivedIncomingTicketsSelector } from '../../store/selectors/incomingMaterialsSelectors';
import { UnreadNotice } from './UnreadNotice';

/**
 * Incoming Materials arrival dot (DEV-4154): binds the shared UnreadNotice
 * dot to incoming-tickets state. Shows while any open incoming ticket has
 * arrived (truck statused OnJob or beyond); clears when those tickets close.
 * Rendered on the route button normally, and on the incoming tickets action
 * button while the user is on the incoming materials page (see
 * App.getFeaturedNavItems / navUtil).
 */
export default connect((state: ReduxState) => ({
  show: hasArrivedIncomingTicketsSelector(state),
  dataTest: 'incoming-materials-notice',
}))(UnreadNotice);
